// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__wvmBS","noInteraction":"EventWrapper_noInteraction__1m3T9","pointerPassthrough":"EventWrapper_pointerPassthrough__1Lfvj"};